Ext.define('SA.view.ArrowMenu', {
    alias: 'widget.arrow-menu',
    extend: 'Ext.menu.Menu',

    alignment: 'top',
    behaveAsWindow: false,
    floating: false,
    frame: true,
    header: false,
    ignoreTargetMouseDown: false,
    shrinkWrap: 3,

    constructor(cfg) {
        cfg = cfg || {};

        var getConfig = setting => (setting in cfg) ? cfg[setting] : this[setting];

        if (getConfig('behaveAsWindow')) {
            cfg = Object.assign({
                canActivateItem: Ext.emptyFn,
                enableKeyNav: false,
                hidden: !getConfig('autoShow')
            }, cfg);
        }

        this.callParent([cfg]);
    },

    initComponent() {
        var floatCt = this.getFloatingAncestor();

        this.addCls('sa-arrow-menu');

        this.renderTo = this.renderTo || Ext.getBody();

        this.plugins = [{ptype: 'sa-arrow'}].concat(this.plugins || []);

        this.callParent();

        if (floatCt) {
            this.mon(floatCt, {
                activate: this.syncPosition,
                beforecollapse: this.close, 
                resize: this.syncPosition,

                scope: this
            });
        }

        this.mon(this.target, {
            beforedestroy: this.close,
            move: this.syncPosition,
            resize: this.syncPosition,

            scope: this
        });
    },

    getFloatingAncestor() {
        return this.target.up('[floating]');
    },

    onBoxReady() {
        this.callParent(arguments);

        this.syncPosition();
    },

    onRender() {
        var me = this;

        setTimeout(() => {
            this.mon(Ext.getDoc(), {
                mousedown,
                touchstart: mousedown
            });

            function mousedown(ev, target) {
                if (me.ignoreTargetMouseDown && me.target.el.contains(target)) {
                    return;
                }

                var ids = {},
                    cmps = me.query();

                cmps.push(me);

                cmps.forEach(cmp => {
                    ids[cmp.id] = true;
                });

                for ( ; target && target !== document ; target = target.parentNode) {
                    if (ids[target.getAttribute('id')]) {
                        return;
                    }
                }

                me.close();
            }
        }, 10);

        this.callParent(arguments);
    },

    syncPosition() {
        if (this.isHidden()) {
            return;
        }

        var target = this.target,
            floatCt = this.getFloatingAncestor() || target,
            positionEl = this.positionEl || target.getEl(),
            xy = Ext.fly(positionEl).getXY(),
            {height: targetHeight, width: targetWidth} = (positionEl.dom || positionEl).getBoundingClientRect(),
            width = this.getWidth(),
            height = this.getHeight(),
            viewportWidth = Ext.dom.Element.getViewportWidth(),
            viewportHeight = Ext.dom.Element.getViewportHeight(),
            constrain = Ext.Number.constrain,
            x = constrain(xy[0] + (targetWidth - width) / 2, 5, viewportWidth - width - 5),
            y = constrain(xy[1] + (targetHeight - height) / 2, 5, viewportHeight - height - 5),
            alignment = this.alignment.split('-'),
            leftSpace, rightSpace;

        switch (alignment[1]) {
            case 'down':
                y = constrain(xy[1] + targetHeight / 2 - 18, 5, viewportHeight - height - 5);
            break;

            case 'up':
                y = constrain(xy[1] + targetHeight / 2 + 18 - height, 5, viewportHeight - height - 5);
            break;
        }

        alignment = alignment[0];

        switch (alignment) {
            case 'left':
            case 'right':
            case 'left/right':
                leftSpace = xy[0] - width - 15;
                rightSpace = viewportWidth - xy[0] - targetWidth - width - 15;

                if (leftSpace < 0 || rightSpace < 0 || alignment === 'left/right') {
                    alignment = leftSpace < rightSpace ? 'right' : 'left';
                }
            break;
        }

        switch (alignment) {
            case 'top':
                this.showAt(x, xy[1] - height - 7);
            break;

            case 'bottom':
                this.showAt(x, xy[1] + targetHeight + 7);
            break;

            case 'left':
                this.showAt(xy[0] - width - 7, y);
            break;

            case 'right':
                this.showAt(xy[0] + targetWidth + 7, y);
            break;
        }

        this.el.setStyle('z-index', (+floatCt.el.getStyle('z-index') || 0) + 1000);

        this.getPlugin('sa-arrow').setTarget(positionEl);
    }
});